// extracted by mini-css-extract-plugin
module.exports = {"card":"ordercard_card__2zFlK"};